import httpClient from './httpClient'

class CreativeFolderApi {
  static async create(data) {
    try {
      const res = await httpClient.post(`/creative_folder`, {
        ownerProfileId: data.ownerProfileId,
        name: data.name,
        isRoot: data.isRoot,
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async update(id, data) {
    try {
      const res = await httpClient.put(`/creative_folder/${id}`, {
        name: data.name,
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async delete(id) {
    try {
      const res = await httpClient.delete(`/creative_folder/${id}`)
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async getListByOwnerProfileId(ownerProfileId) {
    try {
      const params = { owner_profile_id: ownerProfileId }
      const res = await httpClient.get(`/creative_folder`, { params })
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }
}

export default CreativeFolderApi
